import React, { useMemo } from 'react'
import { useCurrentOrg } from 'auth/hooks'
import { mapEventGeofencingToGeofencing } from '../../utils/event'
import { Organization } from 'organization/types'
import OrganizationSettingsScreen from 'volunteering/organizations/components/OrganizationSettingsScreen'
import { FormModal } from 'components/FormModal'
import { resolveOrgAdminLocales } from 'i18n/adminLocales'
import { useInternationalizationEnabled } from 'i18n/feature'

export default function OrganizationSettingsModal(props: {
  showing: boolean
  complete: (...props: any) => Promise<any>
  cancel: () => Promise<any>
  organization?: Organization
}) {
  const { organization, showing, cancel, complete } = props
  const currOrg = useCurrentOrg()
  const org = organization ?? currOrg
  const internationalizationEnabled = useInternationalizationEnabled()
  const initialValues = useMemo(() => {
    const base = {
      address: {
        ...org.address,
        geofencing: mapEventGeofencingToGeofencing({ ...org, radius: 0 }),
      },
      sandboxModeEnabled: org.sandboxModeEnabled,
      limitFutureEventVisibility: org.limitFutureEventVisibility,
      futureEventVisibilityDays: org.futureEventVisibilityDays,
      replyToEmail: org.replyToEmail,
    }
    if (!internationalizationEnabled) {
      return base
    }
    const { supportedAdminLocales, defaultAdminLocale } = resolveOrgAdminLocales(org)
    return { ...base, supportedAdminLocales, defaultAdminLocale }
  }, [org, internationalizationEnabled])

  return (
    <FormModal id={'trip-prompt'} showing={showing} close={cancel} title="Edit Organization Details">
      <OrganizationSettingsScreen
        formData={initialValues as any}
        buttonsProps={{
          nextButton: { onClick: complete, caption: 'Save' },
          backButton: { onClick: cancel, caption: 'Cancel' },
        }}
      />
    </FormModal>
  )
}
